// Copyright (c) 2017 Deere & Company

import './index.scss';
import * as ClaimSearchHelper from '../../shared/services/claim-search-helper';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import AccordionList from '../state/accordion-list';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import AllClaimsFacets from './all-claims-facets';
import AllClaimsHeader from './all-claims-header';
import AllClaimsPanel from './all-claims-panel';
import AllClaimsResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import Facets from '../state/facets';
import {FormattedMessage} from 'react-intl';
import LaborRateLinkPanel from '../../shared/components/labor-rate-link-panel';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import ReportLinks from '../../../shared/components/report-links';
import SearchBox from '../../../shared/components/search-box';
import SearchByDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getClaimsColumns} from '../../shared/services/claims-excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';
import {hasAccess} from '../../../shared/services/security';
import {scrollAccordionIntoView} from '../../shared/services/claim-shared-helper';

const initializeDealerFacet = (props, context) => {

    if (props.facets.dealerAccountsFacet.isInitialLoad || props.facets.dealerAccountsFacet.selectedDealers.length === 0) {

        props.actions.selectAllDealersOnInitialLoad(props.facets.dealerAccountsFacet.allowedDealers);
        props.actions.selectDateOnInitialLoad(context.user.settings.claims.numberOfDays);

    }

};

const initializeStatusFacet = props => {

    if (props.facets.claimStatusFacet.isInitialLoad || props.facets.claimStatusFacet.selectedClaimStatus.length === 0) {

        props.actions.selectAllClaimStatusOnInitialLoad(props.facets.claimStatusFacet.allowedStatus);

    }

};

const initializeNeededData = (props, context) => {

    const showWaitingForDealerInvoice = context.user.privacy.showWaitingForDealerInvoice;

    props.actions.readClaimTypes();
    props.actions.readAllClaims(true, showWaitingForDealerInvoice);

    if (showWaitingForDealerInvoice) {

        props.actions.readDealerInvoices(true);

    }

};

function handleReportsAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('claims');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'claims');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.claims.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('claims', this.exportToExcel.selectedExcelLayout.claims.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.claims);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'claims');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('claims', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'claims');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleActionClick() {

    this.actions.updateCreateClaimModalVisibility(true, '');

}

function handleDownloadToExcel() {

    const showDealerInvoice = this.context.user.privacy.showWaitingForDealerInvoice;

    this.props.actions.exportToExcel(
        this.props.facets,
        this.context.user.getLocale(),
        showDealerInvoice,
        this.props.exportToExcel.selectedExcelLayout.claims.name,
        'claims'
    );

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function handleCreateClaimModalClose() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.claims.name, this.exportToExcel.selectedExcelLayout.claims.listId, 'claims');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.claims.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'claims');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleClick(key, pin) {

    this.actions.onCreateClaim(key, pin);

}

function handleAccordionToggle(accordionId) {

    const toggledAccordion = document.querySelectorAll(`.accordion.${accordionId}`);

    const originalScrollPosition = window.pageYOffset;

    const originalAccordionPosition = toggledAccordion[0].offsetTop;

    const accordionToggle = new Promise(resolve => {

        resolve(this.actions.toggleAccordion(accordionId, this.claimsAccordion));

    });

    accordionToggle.then(() => {

        const newAccordionPosition = toggledAccordion[0].offsetTop;

        const newScrollPosition = originalScrollPosition + (newAccordionPosition - originalAccordionPosition);

        window.scrollTo(0, newScrollPosition);

    }).catch(error => {

        throw error;

    });

}

class AllClaims extends Component {

    componentWillMount() {

        initializeDealerFacet(this.props, this.context);
        initializeStatusFacet(this.props);
        initializeNeededData(this.props, this.context);

        if (this.props.queryParams.status) {

            this.props.actions.openAccordion(this.props.queryParams.status);

        }

    }

    componentDidUpdate() {

        if (this.props.queryParams.status) {

            scrollAccordionIntoView(this.props.queryParams.status);

        }

    }

    componentWillUnmount() {

        this.props.actions.updateCreateClaimModalVisibility(false);
        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.allClaims];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, ClaimSearchHelper.getFilterOptions(), sortedCollection);

        const accordionCollection = ClaimSearchHelper.groupClaimData(this.props.facets.claimStatusFacet.allowedStatus, sortedCollection);

        return (
            <section className='claim-search'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='aside-container'>
                    <AllClaimsFacets/>
                    <LaborRateLinkPanel/>
                    <div className='report-links'>
                        <ReportLinks
                            accordion={this.props.reportsAccordion}
                            onAccordionToggle={this.props::handleReportsAccordionToggle}
                            parentRoute='claims'
                            routes={this.props.reportsRoutes}
                        />
                    </div>
                </aside>
                <main className='claim-search-main'>
                    <div className='button-group'>
                        {hasAccess(this.context.security, 'CLAIM', 'CLM_CLAIM_CREATE') &&
                            <button
                                className='primary-button'
                                onClick={this.props::handleActionClick}
                                type='button'
                            >
                                <FormattedMessage id='CREATE_CLAIM'/>
                            </button>
                        }
                    </div>
                    <SearchBox
                        defaultOption={this.props.searchByDropDown.selectedOption.key}
                        onOptionChange={this.props.actions.updateSearchByDropDown}
                        onQueryChange={this.props.actions.updateSearchQueryString}
                        onSearch={this.props::handleSearch}
                        placeholderText={ClaimSearchHelper.mapSearchPlaceHolder(this.props.searchByDropDown.selectedOption.key)}
                        queryString={this.props.searchQueryString}
                        searchBy={this.props.searchByDropDown.searchBy}
                    />
                    <AllClaimsHeader
                        allClaimsCount={this.props.allClaims.length}
                        claimSearchCount={this.props.claimSearchCount}
                        dealerInvoiceCount={this.props.dealerInvoiceCount}
                        hasSearchResults={this.props.hasSearchResults}
                    />
                    <section className='claim-search-results-container'>
                        <RefinableListWidgetWithExportAndLayouts
                            excelLayouts={this.props.exportToExcel.excelLayouts.claims}
                            onCreateLayout={this.props::handleCreateExcelLayout}
                            onEditLayout={this.props::handleEditExcelLayout}
                            onExport={this::handleDownloadToExcel}
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onLayoutChange={this.props::handleExcelLayoutChange}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            selectedLayout={this.props.exportToExcel.selectedExcelLayout.claims}
                            sortOptions={ClaimSearchHelper.getAllClaimsSortOptions()}
                            type={State}
                        />
                        {this.props.facets.claimStatusFacet.allowedStatus.map((status, index) => accordionCollection[status.key].length > 0 &&
                            <AllClaimsPanel
                                actions={this.props.actions}
                                allClaims={accordionCollection[status.key]}
                                busyCounter={this.props.busyCounter}
                                claimsAccordion={ClaimSearchHelper.getAccordionItem(this.props.claimsAccordion.accordionList, status.key)}
                                key={index}
                                onAccordionToggle={this.props::handleAccordionToggle}
                                status={status.key}
                            />)
                        }
                    </section>
                    <CreateClaimModal
                        claimTypes={this.props.createClaimModal.claimTypes}
                        isModalOpen={this.props.createClaimModal.isModalOpen}
                        onClick={this.props::handleClick}
                        onCloseButtonClick={this.props::handleCreateClaimModalClose}
                        selectedPin={this.props.createClaimModal.selectedPin}
                    />
                    <ExcelLayoutModal
                        excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                        mappingTable={getClaimsColumns().listColumns}
                        onColumnMove={this.props::handleColumnMove}
                        onColumnPush={this.props::handleColumnPush}
                        onColumnRemove={this.props::handleColumnRemove}
                        onLayoutDelete={this.props::handleExcelLayoutDelete}
                        onLayoutNameBlur={this.props::handleLayoutNameBlur}
                        onLayoutNameChange={this.props::handleLayoutNameChange}
                        onModalClose={this.props::handleExcelLayoutModalClose}
                        onSaveLayout={this.props::handleSaveExcelLayout}
                        onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        sortByList={getSortByList(getClaimsColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                    />
                </main>
            </section>
        );

    }

}

AllClaims.displayName = 'AllClaims';
AllClaims.propTypes = {
    actions: PropTypes.object.isRequired,
    allClaims: PropTypes.arrayOf(PropTypes.instanceOf(AllClaimsResult)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    claimSearchCount: PropTypes.number.isRequired,
    claimsAccordion: PropTypes.instanceOf(AccordionList).isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    dealerInvoiceCount: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    hasSearchResults: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired
};
AllClaims.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default AllClaims;



// WEBPACK FOOTER //
// ./src/claim/all-claims/components/index.js